import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import ChoiceChips from 'components/Form/choiceChips';
import DateRangeFields from 'components/Form/dateRangeFields';
import FilterDrawerShell from 'components/Form/filterDrawerShell';
import FilterSection, { FilterField } from 'components/Form/filterSection';
import FilterSelect from "components/Form/filterSelect";
import { countActive, filterValueOf, resolveMultiValue } from 'components/Form/filterValues';
import { genderOptions, jobStatusOptions, residencyOptions } from 'utils/constants';

const referralOptions = [
  { label: 'All', value: 'all' },
  { label: 'Yes', value: 'true' },
  { label: 'No', value: 'false' }
];

const SECTION_KEYS = {
  application: ["applied_at_after", "applied_at_before", "status", "is_internal_referral"],
  candidate: ["gender", "nationality", "residence_status"],
};

const FilterDrawer = ({
    handleFilterDrawer,
    showFilterDrawer,
    handleFilterChange,
    filters,
    handleApplyFilter,
    filterLoading,
    handleDateChange,
    handleClearAll,
    isFilterDirty
}) => {
  const { nationality, nationalityLoading } = useSelector((state) => state.common);
  const [nationalityOption, setNationalityOption] = useState([]);
  useEffect(() => {
    setNationalityOption((nationality || []).map(item => ({ label: item.name, value: item.id })));
  }, [nationality]);

  const valueOf = (key) => filterValueOf(filters, key);

  return (
    <FilterDrawerShell
      open={showFilterDrawer}
      onClose={handleFilterDrawer}
      activeCount={countActive(filters, Object.values(SECTION_KEYS).flat())}
      onClearAll={handleClearAll}
      onApply={handleApplyFilter}
      applying={filterLoading}
      applyDisabled={!isFilterDirty}
    >
      <FilterSection title="Application" count={countActive(filters, SECTION_KEYS.application)}>
        <DateRangeFields
          label="Applied"
          fromId="applied_at_after"
          toId="applied_at_before"
          fromValue={valueOf("applied_at_after")}
          toValue={valueOf("applied_at_before")}
          onFromChange={(v) => handleDateChange(v, "applied_at_after")}
          onToChange={(v) => handleDateChange(v, "applied_at_before")}
        />
        <FilterField label="Status">
          <ChoiceChips ariaLabel="Application status" options={jobStatusOptions} value={valueOf("status")} onChange={(option) => handleFilterChange(option, "status")} />
        </FilterField>
        <FilterField label="Employee referral">
          <ChoiceChips ariaLabel="Employee referral" options={referralOptions} value={valueOf("is_internal_referral")} onChange={(option) => handleFilterChange(option, "is_internal_referral")} />
        </FilterField>
      </FilterSection>

      <FilterSection title="Candidate" count={countActive(filters, SECTION_KEYS.candidate)}>
        <FilterField label="Nationality" hint="one or more" htmlFor="filter-resume-nationality">
          <FilterSelect inputId="filter-resume-nationality" isMulti={true} checkboxMenu={true} maxVisibleValues={2} menuPosition="fixed" isClearable={true} onChange={e=>{handleFilterChange(e, "nationality")}} optionLabel={"label"} optionValue={'value'} options={nationalityOption} isLoading={nationalityLoading} value={resolveMultiValue(valueOf("nationality"), nationalityOption)} placeholder={"Any"} noOptionsLabel={"nationalities"}/>
        </FilterField>
        <FilterField label="Gender">
          <ChoiceChips ariaLabel="Gender" options={genderOptions} value={valueOf("gender")} onChange={(option) => handleFilterChange(option, "gender")} />
        </FilterField>
        <FilterField label="Residency">
          <ChoiceChips ariaLabel="Residency status" options={residencyOptions} value={valueOf("residence_status")} onChange={(option) => handleFilterChange(option, "residence_status")} />
        </FilterField>
      </FilterSection>
    </FilterDrawerShell>
  );
};
export default FilterDrawer;
